import { CarId } from "./protocol";

export const GOAL_RACE_TIME_MS: Record<CarId, number> = {
  car1: 3_649_975,
  car6: 3_650_204,
  car14: 3_649_722,
};

export function clampRaceTime(carId: CarId, raceTimeMs: number): number {
  return Math.max(0, Math.min(GOAL_RACE_TIME_MS[carId], Math.round(raceTimeMs)));
}

export function raceProgress(carId: CarId, raceTimeMs: number): number {
  return clampRaceTime(carId, raceTimeMs) / GOAL_RACE_TIME_MS[carId];
}

export function formatRaceTime(raceTimeMs: number): string {
  const bounded = Math.max(0, Math.round(raceTimeMs));
  const minutes = Math.floor(bounded / 60_000);
  const seconds = Math.floor((bounded % 60_000) / 1_000);
  const milliseconds = bounded % 1_000;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}.${String(milliseconds).padStart(3, "0")}`;
}
